import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	headingV2: {
		id: 'servicedesk-settings-virtual-agent-landing.header.heading-v-2',
		defaultMessage: 'Virtual service agent',
		description:
			'Heading on the page that the user sees when they land on the virtual service agent.',
	},
	heading: {
		id: 'servicedesk-settings-virtual-agent-landing.header.heading',
		defaultMessage: 'Virtual agent',
		description: 'Heading on the page that the user sees when they land on the virtual agent.',
	},
	descriptionSubheadingV2: {
		id: 'servicedesk-settings-virtual-agent-landing.header.description-subheading-v-2',
		defaultMessage:
			'Save your team hours of work with the virtual service agent: a conversational support tool that learns to recognize questions and requests, then automatically responds and takes action. <link>Find out more about the virtual service agent</link>',
		description:
			'Virtual service agent landing page subheading explain what the virtual service agent is.',
	},
	descriptionSubheading: {
		id: 'servicedesk-settings-virtual-agent-landing.header.description-subheading',
		defaultMessage:
			'Save your team hours of work with the virtual agent: a conversational support tool that learns to recognize questions and requests, then automatically responds and takes action. <link>Find out more about the virtual agent</link>',
		description: 'Virtual agent landing page subheading explain what the virtual agent is.',
	},
	machineLearningSubheadingV2: {
		id: 'servicedesk-settings-virtual-agent-landing.header.machine-learning-subheading-v-2',
		defaultMessage:
			'The virtual service agent develops and trains a machine learning model that’s tailored to your organization, based on a training data set. <link>Find out more about how the data set is trained</link>',
		description:
			'Virtual service agent landing page subheading explaining the machine learning model.',
	},
	machineLearningSubheading: {
		id: 'servicedesk-settings-virtual-agent-landing.header.machine-learning-subheading',
		defaultMessage:
			'The virtual agent develops and trains a machine learning model that’s tailored to your organization, based on a training data set. <link>Find out more about how the data set is trained</link>',
		description: 'Virtual agent landing page subheading explaining the machine learning model.',
	},
	upgradeToPremiumDescriptionV2: {
		id: 'servicedesk-settings-virtual-agent-landing.header.upgrade-to-premium-description-v-2',
		defaultMessage: 'Upgrade to a Premium or Enterprise plan to use the virtual service agent.',
		description: 'Description for users who are not premium or enterprise customers.',
	},
	upgradeToPremiumDescription: {
		id: 'servicedesk-settings-virtual-agent-landing.header.upgrade-to-premium-description',
		defaultMessage: 'Upgrade to a Premium or Enterprise plan to use the virtual agent.',
		description: 'Description for users who are not premium or enterprise customers.',
	},
	upgradeToPremiumNotSiteAdminDescriptionV2: {
		id: 'servicedesk-settings-virtual-agent-landing.header.upgrade-to-premium-not-site-admin-description-v-2',
		defaultMessage:
			'You need to be on a Premium or Enterprise plan to use the virtual service agent. Contact your administrator to upgrade.',
		description: 'Description for users who are not premium or enterprise customers.',
	},
	upgradeToPremiumNotSiteAdminDescription: {
		id: 'servicedesk-settings-virtual-agent-landing.header.upgrade-to-premium-not-site-admin-description',
		defaultMessage:
			'You need to be on a Premium or Enterprise plan to use the virtual agent. Contact your administrator to upgrade.',
		description: 'Description for users who are not premium or enterprise customers.',
	},
	aiLogoLabelV2: {
		id: 'servicedesk-settings-virtual-agent-landing.header.ai-logo-label-v-2',
		defaultMessage: 'The virtual service agent requires Atlassian Intelligence to be enabled',
		description: 'Label for the Atlassian Intelligence logo when shown on landing page.',
	},
	aiLogoLabel: {
		id: 'servicedesk-settings-virtual-agent-landing.header.ai-logo-label',
		defaultMessage: 'The virtual agent requires Atlassian Intelligence to be enabled',
		description: 'Label for the Atlassian Intelligence logo when shown on landing page.',
	},
});
